import { styled } from '@mui/material';
import { Box, Typography } from 'ui';

interface IProps {
  title: string;
  subTitle?: string;
}

export const Header = ({ title, subTitle }: IProps) => {
  return (
    <HeaderBox>
      <Typography color="text.primary" variant="h4">
        {title}
      </Typography>
      {subTitle && (
        <Typography color="text.secondary" variant="body1">
          {subTitle}
        </Typography>
      )}
    </HeaderBox>
  );
};

const HeaderBox = styled(Box)(({ theme }) => ({
  marginBottom: theme.spacing(1)
}));

export default Header;
